<template>
  <div :class="[themeBackground]">
    <app-header></app-header>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <app-footer></app-footer>
    <modals-wrapper />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppHeader from "../../components/header/AppHeader";
import AppFooter from "../../components/footer/AppFooter";
import ModalsWrapper from "@/components/modal/ModalsWrapper";

export default {
  name: "AppContainer",

  components: {
    AppHeader,
    AppFooter,
    ModalsWrapper
  },

  computed: {
    ...mapGetters("theme", {
      themeBackground: "getThemeBackground"
    })
  }
};
</script>

<style lang="scss">
.dark {
  background-color: $background-dark--1;
  color: $primary-color;

  .v--modal {
    background-color: $background-dark--2;
  }
}
</style>
